import React, { useState, useRef, useEffect } from 'react';
import { Home, SlidersHorizontal, ChevronDown, Bookmark, Bell } from 'lucide-react';
import { PROVINCE_NAMES, ALL_PROVINCES } from './provinces.jsx';

const OPTIONS = [ALL_PROVINCES, ...PROVINCE_NAMES];
import './topBar.scss';


// «همه‌ی طراحی‌ها» یا «خانه‌های واقعی» (فقط آگهی‌های مشاورین املاک) — کنارِ انتخابِ استان، در اکسپلور
export const KINDS = [
  { id: 'all', label: 'همه‌ی طراحی‌ها', hint: 'طراحی‌های همه‌ی کاربران و آگهی‌ها' },
  { id: 'real', label: 'خانه‌های واقعی', hint: 'فقط فایل‌های مشاورین املاک (خرید و اجاره)' },
];

// onSavedClick: دکمه‌ی «ذخیره‌شده‌ها» (فقط اگر داده شود). kind/onKindChange: فیلترِ «همه/واقعی» (فقط اگر داده شود)
// onAlertsClick: زنگوله‌ی «هشدارهای آگهیِ جدید» (فقط برای کاربرِ واردشده)؛ alertsCount = آگهی‌های تازه‌ی دیده‌نشده
function TopBar({ defaultProvince = 'تهران', province: controlled, onProvinceChange, onFilterClick, onSavedClick, savedCount = 0, kind, onKindChange, filterCount = 0, onAlertsClick, alertsCount = 0 }) {
  const [isOpen, setIsOpen] = useState(false);
  const [kindOpen, setKindOpen] = useState(false);
  const kindRef = useRef(null);
  const [own, setProvince] = useState(defaultProvince);
  const province = controlled || own;
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (kindRef.current && !kindRef.current.contains(event.target)) {
        setKindOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (name) => {
    setProvince(name);
    setIsOpen(false);
    onProvinceChange?.(name);
  };

  return (
    <header className="top-bar">
      <div className="top-bar__logo" aria-label="خانه‌رو">
        <Home size={24} strokeWidth={2} />
      </div>

      <div className="top-bar__center">
      {onKindChange && (
        <div className="top-bar__kind" ref={kindRef}>
          <button
            type="button"
            className={`top-bar__kind-trigger ${kind === 'real' ? 'is-real' : ''}`}
            onClick={() => setKindOpen((v) => !v)}
            aria-expanded={kindOpen}
          >
            <span>{(KINDS.find((k) => k.id === kind) || KINDS[0]).label}</span>
            <ChevronDown size={14} strokeWidth={2} className={`top-bar__chevron ${kindOpen ? 'is-open' : ''}`} />
          </button>
          {kindOpen && (
            <ul className="top-bar__dropdown top-bar__kind-list" role="listbox">
              {KINDS.map((k) => (
                <li key={k.id}>
                  <button
                    type="button"
                    className={`top-bar__option ${k.id === kind ? 'is-selected' : ''}`}
                    onClick={() => {
                      setKindOpen(false);
                      onKindChange(k.id);
                    }}
                    role="option"
                    aria-selected={k.id === kind}
                  >
                    {k.label}
                    <small>{k.hint}</small>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
      <div className="top-bar__province" ref={dropdownRef}>
        <button
          type="button"
          className="top-bar__province-trigger"
          onClick={() => setIsOpen((prev) => !prev)}
          aria-expanded={isOpen}
        >
          <span>{province}</span>
          <ChevronDown
            size={16}
            strokeWidth={2}
            className={`top-bar__chevron ${isOpen ? 'is-open' : ''}`}
          />
        </button>

        {isOpen && (
          <ul className="top-bar__dropdown" role="listbox">
            {OPTIONS.map((name) => (
              <li key={name}>
                <button
                  type="button"
                  className={`top-bar__option ${name === province ? 'is-selected' : ''}`}
                  onClick={() => handleSelect(name)}
                  role="option"
                  aria-selected={name === province}
                >
                  {name}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
      </div>

      <div className="top-bar__end">
        {onAlertsClick && (
          <button type="button" className="top-bar__filter top-bar__alerts" onClick={onAlertsClick} aria-label="هشدارهای آگهیِ جدید">
            <Bell size={22} strokeWidth={1.8} />
            {alertsCount > 0 && <i className="is-alert">{alertsCount > 99 ? '۹۹+' : alertsCount.toLocaleString('fa-IR')}</i>}
          </button>
        )}
        {onSavedClick && (
          <button type="button" className="top-bar__filter top-bar__saved" onClick={onSavedClick} aria-label="ذخیره‌شده‌ها">
            <Bookmark size={22} strokeWidth={1.8} />
            {savedCount > 0 && <i>{savedCount > 99 ? '۹۹+' : savedCount.toLocaleString('fa-IR')}</i>}
          </button>
        )}
        <button
          type="button"
          className="top-bar__filter"
          onClick={onFilterClick}
          aria-label="فیلتر"
        >
          <SlidersHorizontal size={22} strokeWidth={1.8} />
          {filterCount > 0 && <i>{filterCount.toLocaleString('fa-IR')}</i>}
        </button>
      </div>
    </header>
  );
}

export default TopBar;